import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_PASSWORD_SECRET_KEY;

export const encrypt = (text) => {
  if (!text || !SECRET_KEY) return null;
  return CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
};

export const decrypt = (ciphertext) => {
  if (!ciphertext || !SECRET_KEY) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    console.error("Decryption error:", err.message);
    return null;
  }
};
